import React, { Component } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import Video from "../Video/Video";

export default class VideoThumbnail extends Component {
  sectionClasses() {
    return classNames({
      "video-thumbnail": true,
      "-voting": this.props.votingMode,
      "-award": this.props.awardMode,
      // "-selected": this.props.selected
    });
  }
  render() {
    return this.props.votingMode
      ? (<div className={this.sectionClasses()} style={{paddingTop: '1%'}}>
        <Video hideCaption video={this.props.video} />
        {this.props.awardMode && (
          <div className="award-indicator">
            <i className="icon-star" />
          </div>
        )}
        <div
          className="caption"
          onClick={
            this.props.votingMode &&
            (e => {
              e.preventDefault();
              this.props.toggleVideo();
            })
          }
        >
          <div>
            <h3>{this.props.video.name}</h3>
            <p>{this.props.video.title}</p>
          </div>
          {this.props.votingMode
            ? (this.props.selected ? <div className="selected">Selected</div> : <div className="select">Select</div>)
            : null
          }
        </div>
      </div>)
      :(<Link
          className={this.sectionClasses()}
          target="_blank"
          to={`/competition/${this.props.competitionSlug}/video/${this.props.id}`}
          onClick={
            this.props.votingMode &&
            (e => {
              e.preventDefault();
              this.props.onOpenVideo();
            })
          }
        >
          <div
            className="video-container"
            style={{
              backgroundImage: `url('${this.props.video.publicThumbnail}')`
            }}
          />
          {/*{this.props.votingMode && (*/}
            {/*<div className="checkbox">*/}
              {/*{this.props.selected && <i className="icon-check" />}*/}
            {/*</div>*/}
          {/*)}*/}
          {this.props.awardMode && (
            <div className="award-indicator">
              <i className="icon-star" />
            </div>
          )}
          <div
            className="caption"
            onClick={
              this.props.votingMode &&
              (e => {
                e.preventDefault();
                this.props.toggleVideo();
              })
            }
          >
            <div>
              <h3>{this.props.video.name}</h3>
              <p>{this.props.video.title}</p>
            </div>
            {this.props.votingMode
              ? (this.props.selected ? <div className="selected">Selected</div> : <div className="select">Select</div>)
              : null
            }
          </div>
        </Link>
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/VideoThumbnail/VideoThumbnail.js